export class MeRightMail {
  iCourrierWriteAuthorized: boolean;
  edit: boolean;
  pin: boolean;
  viewHistory: boolean;
  viewDroits: boolean;
  canArchive: boolean;
  answerMail: boolean;
  mauvaisRoutageMail: boolean;
  markAPrendreEnCharge: boolean;
  prendreEnChargeExclusive: boolean;
  prendreEnChargeCollaborative: boolean;
  refuserPriseEnCharge: boolean;
  annulerPriseEnCharge: boolean;
  cloturerPrendreEnCharge: boolean;
  canDeleteMail: boolean;
  canMoveToBac: boolean;
  validate: boolean;

  files: MeRightMailFiles;
  distribution: MeRightMailDistribution;
  comments: MeRightMailDistributionComments;
}

export interface MeRightMailFiles {
  view: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
  open: boolean;
  viewVersions: boolean;
  addVersions: boolean;
}

export interface MeRightMailDistribution {
  addUser: boolean;
  deleteUser: MeRightMailDistributionDeleteUser[];
  addService: boolean;
  deleteService: boolean;
}
export interface MeRightMailDistributionDeleteUser {
  mailDestinataireId: number;
  delete: boolean;
  replyToAction: boolean;
}

export interface MeRightMailDistributionComments {
  view: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
}
